import styled from 'styled-components';
import BasicInfo from './BasicInfo';
import ShippingList from './ShippingList';
import {
  Button,
  Card,
  Collapse,
  Divider,
  FormControl,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Typography,
} from '@mui/material';
import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import {
  backdropAtom,
  SHIPPING_TYPE,
  shippingListCollapseAtom,
  targetShippingSeqAtom,
  timeLineAtom,
} from '@/commons/constants';
import KeyboardDoubleArrowLeftOutlinedIcon from '@mui/icons-material/KeyboardDoubleArrowLeftOutlined';
import { planShippingListAtom, postTShipping, shippingTargetDetail } from '@/interfaces/plan/shipping';
import { useEffect, useState } from 'react';
import { GridCloseIcon } from '@mui/x-data-grid';
const MainWrap = styled(Card)<{ $collapse: boolean; timelineFlag: boolean }>`
  position: absolute;
  width: auto;
  margin: 1rem;
  height: calc(100% - 2rem);
  overflow: hidden;
  display: grid;
  grid-template-columns: minmax(0, auto) 1.6rem;
  z-index:1;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
  transition: all 0.3s ease-in-out;
  .wrap{
    padding: 1rem;
    width:100%;
    height: 100%;
    overflow: hidden;
    display:flex;
    flex-direction:column;
  }
`;

const CollapseArea = styled.div<{ $collapse: boolean }>`
  width: 1.6rem;
  height: 100%;
  background: #b7d0f7;
  border-left: 0.5px dotted #444444;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
  display: flex;
  align-items: center;
  cursor: pointer;
  .button{
    ${({ $collapse }) => ($collapse === false ? 'transform: rotate(180deg)' : '')}
  }
  transition: all 300ms ease-in-out;
`;

export default function Shipping() {
  const { data } = useAtomValue(shippingTargetDetail);
  const timeLine = useAtomValue(timeLineAtom);
  const [shippingListCollapse, setShippingLIstCollapse] = useAtom(shippingListCollapseAtom);
  const [option, setOption] = useState<number>();

  const [confirm, setConrirm] = useState<boolean>(false);
  useEffect(() => {
    setOption(data?.shipping?.option?.shipping_type);
  }, [data]);

  return (
    <>
      <MainWrap $collapse={shippingListCollapse} timelineFlag={timeLine}>
        {/* 화면 좌측 배차 목록 표시 접기기능을 포함 */}
        <Collapse orientation="horizontal" in={shippingListCollapse} sx={{ height: '100%', overflowY: 'hidden' }}>
          <div className="wrap">
            <div style={{ width: '100%', padding: '0.5rem 0', display: 'flex', gap: '1rem' }}>
              <Typography variant="h6">
                {SHIPPING_TYPE[option]}
                {option
                  ? option === 1 || option === 2
                    ? data?.shipping?.option?.level === 1
                      ? ' 시/도'
                      : ' 구/군'
                    : ''
                  : ''}
              </Typography>
              {/* <FormControl fullWidth size="small">
                <InputLabel id="demo-simple-select-label">배차옵션</InputLabel>
                <Select
                  size="small"
                  label="배차옵션"
                  value={option ?? -1}
                  onChange={(e) => setOption(Number(e.target.value))}
                  disabled={!data?.shipping?.option}
                >
                  
                  <MenuItem value={0}>0 No Sub</MenuItem>
                  <MenuItem value={1}>1 Sub All</MenuItem>
                  <MenuItem value={2}>2 Sub</MenuItem>
                  <MenuItem value={3}>3 30Km All</MenuItem>
                </Select>
              </FormControl>
              <Button
                size="small"
                variant="contained"
                disabled={data?.shipping?.option?.shipping_type == option}
                onClick={() => setConrirm(true)}
              >
                옵션변경
              </Button> */}
              {/* <MenuItem value={2}>최소시간</MenuItem>
                  <MenuItem value={0}>최대체적</MenuItem>
                  <MenuItem value={1}>모든차량</MenuItem> */}
            </div>
            <BasicInfo />
            <ShippingList />
          </div>
        </Collapse>
        {/* collapse가 html5 attribute인지 styled attribute인지 구별을 위핸 *를 추가 (console warning제거) */}
        <CollapseArea $collapse={shippingListCollapse} onClick={() => setShippingLIstCollapse(!shippingListCollapse)}>
          <div className="button">
            <KeyboardDoubleArrowLeftOutlinedIcon htmlColor="#555555" />
          </div>
        </CollapseArea>
      </MainWrap>
      <ConfirmModal
        open={confirm}
        execParam={{ shipping: data?.shipping, option }}
        handleClose={() => setConrirm(false)}
      />
    </>
  );
}

const ModalWrap = styled.div`
  position: absolute;
  top:50%;
  left:50%;
  transform: translate(-50%, -50%);
  width: 25rem;
  height: 10rem;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  .head{
    padding: 0.5rem;
    width: 100%;
    height: 3rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background:rgba(82, 133, 164, 0.87);
    color: #ffffff;
  }
  .body{
    padding: 1rem;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 1rem;
  }
  .button{
    padding: 0 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
  }
`;

const ConfirmModal = ({ open, execParam, handleClose }: { open: boolean; execParam: any; handleClose: any }) => {
  const setBackdrop = useSetAtom(backdropAtom);
  const setTargetShippingSeq = useSetAtom(targetShippingSeqAtom);
  const { refetch: listRefetch } = useAtomValue(planShippingListAtom);
  const handleClickConfirm = async () => {
    setBackdrop(true);
    const ret = await postTShipping({
      deliverDate: execParam.shipping.date,
      r_shipping_seq: execParam.shipping.seq,
      t_shipping_seq: execParam.shipping.t_shipping_seq,
      option: { shipping_type: execParam.option },
    });
    setBackdrop(false);
    if (ret && ret.data.data.t_shipping_seq) {
      listRefetch();
      setTargetShippingSeq(ret.data.data.t_shipping_seq);
      handleClose();
    } else {
      alert('예기치 않은 오류로 배차에 실패하였습니다.');
      handleClose();
    }
  };
  return (
    <Modal open={open} onClose={handleClose}>
      <ModalWrap>
        <div className="head">
          <Typography variant="h5">배차옵션 변경</Typography>
          <GridCloseIcon onClick={handleClose} />
        </div>
        <Divider />
        <div className="body">
          <Typography>
            '{SHIPPING_TYPE[execParam.option]}'으로 배차 옵션을 변경하는 경우 수동편집한 내용은 소실됩니다.
            <br /> 배차 옵션을 변경하시겠습니까?
          </Typography>
        </div>
        <div className="button">
          <Button variant="contained" fullWidth color="warning" onClick={handleClose}>
            취소
          </Button>
          <Button variant="contained" fullWidth onClick={handleClickConfirm}>
            실행
          </Button>
        </div>
      </ModalWrap>
    </Modal>
  );
};
